// ----------------------------------------------------------------------------
// Quantity Selector Extension (Validate B2B Quantity Limits)
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import Debug from 'scripts/libs/debug';

// -------------------------------------
// Functionality
// -------------------------------------

var validationRules = {
  max: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant;
      return ((_itemData$variant = itemData.variant) === null || _itemData$variant === void 0 || (_itemData$variant = _itemData$variant.quantity_rule) === null || _itemData$variant === void 0 ? void 0 : _itemData$variant.max) || null;
    },
    condition_callback: (current_quantity, max_quantity) => current_quantity <= max_quantity,
    error_message: (current_quantity, max_quantity, itemData) => translate('You can only add up to {{ MAX_QUANTITY }} of {{ itemData.variant.name }}.', 'quantity.error.limit_max', {
      QUANTITY: current_quantity,
      MAX_QUANTITY: max_quantity,
      itemData
    })
  },
  min: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant2;
      return ((_itemData$variant2 = itemData.variant) === null || _itemData$variant2 === void 0 || (_itemData$variant2 = _itemData$variant2.quantity_rule) === null || _itemData$variant2 === void 0 ? void 0 : _itemData$variant2.min) || null;
    },
    condition_callback: (current_quantity, min_quantity) => current_quantity === 0 || current_quantity >= min_quantity,
    error_message: (current_quantity, min_quantity, itemData) => translate('You must add at least {{ MIN_QUANTITY }} of {{ itemData.variant.name }}.', 'quantity.error.limit_min', {
      QUANTITY: current_quantity,
      MIN_QUANTITY: min_quantity,
      itemData
    })
  },
  step: {
    condition_value: (current_quantity, itemData) => {
      var _itemData$variant3;
      return ((_itemData$variant3 = itemData.variant) === null || _itemData$variant3 === void 0 || (_itemData$variant3 = _itemData$variant3.quantity_rule) === null || _itemData$variant3 === void 0 ? void 0 : _itemData$variant3.step) || null;
    },
    condition_callback: (current_quantity, step) => current_quantity % step === 0,
    error_message: (current_quantity, step, itemData) => translate('You must buy {{ itemData.variant.name }} in increments of {{ STEP }}.', 'quantity.error.limit_step', {
      QUANTITY: current_quantity,
      STEP: step,
      itemData
    })
  }
};
iamotaEventHandler.subscribe('iamForm:quantity:validation:init', _ref => {
  var {
    iamFormElement,
    validator
  } = _ref;
  var quantityInput = iamFormElement;
  var _loop = function _loop(ruleType) {
    var rule = validationRules[ruleType];
    validator.addField(quantityInput.control, [{
      validator: (current_quantity, fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        var result = condition_value === null || rule.condition_callback(parseInt(current_quantity, 10), condition_value, itemData);
        Debug.extreme("Validating Quantity [".concat(ruleType, "]: ").concat(current_quantity, " vs. ").concat(condition_value, " => ").concat(result ? Debug.colors.bgGreen('Valid') : Debug.colors.bgRed('Invalid')), {
          current_quantity,
          condition_value,
          result,
          itemData,
          fields
        });
        return result;
      },
      errorMessage: (current_quantity, _fields) => {
        var itemData = quantityInput.getItemData();
        var condition_value = rule.condition_value(current_quantity, itemData);
        return rule.error_message(current_quantity, condition_value, itemData);
      }
    }], {
      errorsContainer: quantityInput.errorContainer
    });
  };
  for (var ruleType in validationRules) {
    _loop(ruleType);
  }
}, {
  source: "quantity-input--b2b-limits.js"
});